import {
    Component,
    OnInit,
    Input,
    ViewChild,
    TemplateRef,
    Output,
    EventEmitter
} from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap";
import { CommonService } from '../../services/index';
@Component({
    selector: "track-history",
    templateUrl: "./trackHistory.html"
})
export class trackHistoryComponent {
    data: any;
    dataval: any;
    columns: any;
    trackdata: any;
    trackdatacnt: any;
    isLoadMask: Promise<any>;
    //@Input('showtrackHistory') showtrackHistory:any;
    @Input() set showTrackHistory(val: any) {
        this.data = val
        let that = this;
        this.isLoadMask = that.commonService
            .getTrackHistory(that.data)
            .then(function (res: any) {
                that.trackdata = res.data;
                that.trackdatacnt = res.totCnt;
                /*if (res.data.length > 0) {
                    res.data[0].description += " " + res.data[0].next_followp_date;
                }*/
            });
    }

    constructor(public commonService: CommonService, public bsModalRef: BsModalRef, private modalService: BsModalService) {

    }
    ngOnInit(): void {

        this.columns = [
            {
                name: "Date",
                prop: "date",
                width: 100,
                minWidth: 100,
                maxWidth: 100,
                toggle: true
            },
            {
                name: "Process",
                prop: "service_process",
                sortable: false,
                width: 250,
                minWidth: 250,
                maxWidth: 250
            },
            {
                name: "Status",
                prop: "service_status",
                sortable: false,
                //cellClass: "cell-left",
                width: 300,
                minWidth: 300,
                maxWidth: 300
            },
            {
                name: "Description",
                prop: "description",
                sortable: false,
                //cellClass: "cell-left",
                width: 320,
                minWidth: 320,
                maxWidth: 320
            }
        ];
    }
    ngAfterViewInit() {

    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/common/trackHistory.ts